import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Check, Globe, Lock, ShieldCheck } from 'lucide-react';
import { CHECKOUT_URL, handleCheckoutClick } from '../utils/checkout';
const INCLUDES = ['Los 6 tomos completos', 'Los 5 bonos incluidos', 'Acceso inmediato', 'Material digital', 'Actualizaciones incluidas', 'Garantía de 7 días'];
export function PricingOptions() {
  // Warm up DNS + TLS to the checkout origin so the redirect is instant on tap
  useEffect(() => {
    const head = document.head;
    const links: HTMLLinkElement[] = [];
    const add = (rel: string, href: string, crossOrigin?: boolean) => {
      const l = document.createElement('link');
      l.rel = rel;
      l.href = href;
      if (crossOrigin) l.crossOrigin = 'anonymous';
      head.appendChild(l);
      links.push(l);
    };
    add('preconnect', 'https://megapackenfermeria.impultienda.ar', true);
    return () => {
      links.forEach(l => {
        if (l.parentNode) l.parentNode.removeChild(l);
      });
    };
  }, []);
  return <section id="pricing" className="relative py-10 md:py-16 bg-clinical-deep text-white overflow-hidden" data-id="element-141" data-mp="3mnmj6nzbe1sk">
      <div className="absolute inset-0 opacity-[0.06] pointer-events-none" data-id="element-142" data-mp="3cvqbqmbc8zbo">
        <div className="absolute inset-0" style={{
        backgroundImage: 'radial-gradient(circle, #ffffff 1.5px, transparent 1.5px)',
        backgroundSize: '32px 32px'
      }} data-id="element-143" data-mp="3ctnk5xujey4u" />
      </div>

      <div className="relative max-w-[520px] mx-auto px-4 sm:px-6" data-id="element-144" data-mp="38ueouojums76">
        <div className="text-center mb-6 md:mb-8" data-id="element-145" data-mp="2twvw7b41vuug">
          <p className="text-[10px] sm:text-xs font-semibold tracking-[0.22em] uppercase text-clinical-accent mb-2.5" data-id="element-146" data-mp="2tyfaiw65bvtl">
            Acceso completo
          </p>
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-black text-white leading-[1.08] uppercase" data-id="element-147" data-mp="s4zka0dz0iz5">
            Mega Pack Enfermería
          </h2>
          <p className="text-sm md:text-base text-white/70 mt-2" data-id="element-148" data-mp="x3svfm5sbxw5">
            6 tomos + 5 bonos incluidos
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-60px'
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="bg-white rounded-3xl p-6 md:p-8 text-clinical-deep shadow-[0_24px_60px_rgba(4,20,38,0.4)]" data-id="element-149" data-mp="qolocwqmmrpv">
          <div className="flex flex-col items-center gap-1 mb-2.5" data-id="element-150" data-mp="14o3htpevat5k">
            <span className="text-xl md:text-2xl font-bold leading-none tracking-tight text-clinical-ink/35 line-through" data-id="element-151" data-mp="14mad4fntej07">
              US$49
            </span>
            <span className="text-[3.6rem] md:text-[4.5rem] font-black leading-[0.9] tracking-tight" data-id="element-152" data-mp="1x4o35t2wt0oq">
              US$12.99
            </span>
          </div>
          <p className="text-center text-[12px] md:text-sm font-semibold text-clinical-ink/70 mb-3" data-id="element-153" data-mp="1sbuyf57fxscn">
            Pago único · Sin suscripciones
          </p>

          <p className="mx-auto mb-6 flex w-fit items-center gap-2 rounded-full bg-clinical-mist border border-clinical-line px-3.5 py-1.5 text-[11.5px] md:text-xs font-bold uppercase tracking-[0.1em] text-clinical-deep" data-id="element-154" data-mp="3g0bsa9pp24ge">
            <Globe size={13} className="text-clinical-mid flex-shrink-0" data-id="element-155" data-mp="3oy44v6416y03" />
            Paga en tu moneda local
          </p>

          <ul className="space-y-2 mb-6 border-t border-clinical-line/70 pt-5" data-id="element-156" data-mp="2t0g9mc3zklr">
            {INCLUDES.map(item => <li key={item} className="flex items-start gap-2.5" data-id="element-157" data-mp="7jgwfe7bdkbt">
                <span className="mt-[3px] flex-shrink-0 w-4 h-4 rounded-full bg-clinical-mist border border-clinical-line flex items-center justify-center" data-id="element-158" data-mp="7m35xjdrm9wo">
                  <Check className="w-2.5 h-2.5 text-clinical-mid" strokeWidth={3} data-id="element-159" data-mp="glq9aaq21psd" />
                </span>
                <span className="text-[13px] md:text-[14px] text-clinical-ink/85 leading-snug" data-id="element-160" data-mp="7w9eoh0xj7zd">
                  {item}
                </span>
              </li>)}
          </ul>

          <a href={CHECKOUT_URL} target="_top" onClick={handleCheckoutClick} className="group flex w-full items-center justify-center gap-2 rounded-full bg-clinical-cta px-6 py-4 md:py-5 text-[14px] md:text-base font-bold uppercase tracking-[0.03em] text-white transition-[transform,background-color] duration-200 ease-out hover:bg-clinical-ctaHover hover:scale-[1.01] active:scale-[0.98] shadow-[0_12px_32px_rgba(15,98,254,0.35)] touch-manipulation" data-id="element-161" data-mp="hmb4bd8xkyge">
            Quiero acceder ahora
            <ArrowRight size={18} className="transition-transform duration-200 ease-out group-hover:translate-x-1 flex-shrink-0" data-id="element-162" data-mp="3q0t6wzg3rlsm" />
          </a>
        </motion.div>

        <div className="mt-5 flex flex-wrap justify-center items-center gap-x-3 gap-y-1.5 text-[11px] sm:text-xs text-white/60" data-id="element-163" data-mp="15bneogfzvcka">
          <span className="flex items-center gap-1.5" data-id="element-164" data-mp="1cy0ttbhm6f24">
            <ShieldCheck size={13} className="text-white/50" data-id="element-165" data-mp="1hvk9mftymzw6" />
            Garantía de 7 días
          </span>
          <span className="text-white/20" data-id="element-166" data-mp="13wkmxdq0cv2n">·</span>
          <span className="flex items-center gap-1.5" data-id="element-167" data-mp="17wbn281fcnju">
            <Lock size={13} className="text-white/50" data-id="element-168" data-mp="17wv1vfvs2vtn" />
            Pago seguro
          </span>
          <span className="text-white/20" data-id="element-169" data-mp="1vmxrlpc7zpp3">·</span>
          <span className="flex items-center gap-1.5" data-id="element-170" data-mp="20ls98nygb87m">
            <Globe size={13} className="text-white/50" data-id="element-171" data-mp="20nd3sdkrmr5h" />
            Disponible en toda LATAM y España
          </span>
        </div>
      </div>
    </section>;
}